// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {AlertBarMessageList} from './alert-bar-message-list';
import AlertMessage from '../../state/alert-message';
import {FormattedMessage} from 'react-intl';
import InfoAlertBar from '../alert-bar/info-alert-bar';

const getDismissHandler = onDismiss =>
    () => {

        onDismiss('info');

    };

export const InfoMessageContainer = props => {

    const title = props.infoMessages.length > 1 ?
        <FormattedMessage id='INFO_MESSAGES_TITLE'/> :
        <FormattedMessage id='INFO_MESSAGE_TITLE'/>;

    const content = props.infoMessages.length > 1 ?
        <AlertBarMessageList messages={props.infoMessages}/> :
        props.infoMessages.length > 0 && props.infoMessages[0].message;

    return (
        <div className='info-message-container'>
            <InfoAlertBar
                alertTitle={title}
                dismissHandler={getDismissHandler(props.onDismiss)}
                willAutoDismiss={true}
            >
                {content}
            </InfoAlertBar>
        </div>
    );

};

InfoMessageContainer.displayName = 'InfoMessageContainer';
InfoMessageContainer.propTypes = {
    infoMessages: PropTypes.arrayOf(PropTypes.instanceOf(AlertMessage)).isRequired,
    onDismiss: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/info-message-container.js